import {api} from './api';

export interface AgentOutputViolation {
    fieldPath: string;
    errorCode: string;
    message: string;
    expected: string;
    actual: string;
}

export interface AgentOutputValidationRecord {
    id: number;
    traceId: string;
    agentId?: number;
    agentName?: string;
    sourceKind?: string;
    sourceId?: string;
    executionPurpose?: string;
    outputKind?: string;
    outputCode?: string;
    turnNo?: number;
    repairAttempt?: number;
    status?: string;
    checkerName?: string;
    retryable?: boolean;
    violationCount?: number;
    createdAt?: string;
}

export interface AgentOutputValidationDetail extends AgentOutputValidationRecord {
    rawOutputJson?: string;
    normalizedOutputJson?: string;
    violations?: AgentOutputViolation[];
    feedbackPrompt?: string;
}

export interface AgentOutputValidationPageResult {
    content: AgentOutputValidationRecord[];
    totalElements: number;
    number: number;
    size: number;
}

export interface AgentOutputValidationQuery {
    agentName?: string;
    status?: string;
    outputKind?: string;
    outputCode?: string;
    traceId?: string;
    startTime?: string;
    endTime?: string;
    page?: number;
    size?: number;
}

class AgentOutputValidationService {
    async getPage(params: AgentOutputValidationQuery): Promise<AgentOutputValidationPageResult> {
        const response = await api.get('/api/v1/agents/output-validations', {params});
        return response.data.data;
    }

    async getDetail(id: number): Promise<AgentOutputValidationDetail> {
        const response = await api.get(`/api/v1/agents/output-validations/${id}`);
        return response.data.data;
    }

    async getTraceTimeline(traceId: string): Promise<AgentOutputValidationDetail[]> {
        const response = await api.get(`/api/v1/agents/output-validations/trace/${traceId}`);
        return response.data.data;
    }
}

export const agentOutputValidationService = new AgentOutputValidationService();
